// @mui material components
import Container from "@mui/material/Container";

// Soft UI Dashboard PRO React components
import SoftBox from "components/SoftBox";

// Soft UI Dashboard PRO React example components
import PageLayout from "examples/LayoutContainers/PageLayout";

// Pricing page components
import Header from "views/root/components/Header";
import Footer from "views/root/components/Footer";
import { Card, Grid, Icon } from "@mui/material";
import SoftBadge from "components/SoftBadge";
import SoftTypography from "components/SoftTypography";
import { Business, Mail, Phone } from "@mui/icons-material";

function ContactUs() {
  return (
    <PageLayout>
      <Header displayText={false} />
      <Container>
        <SoftBox position="relative" zIndex={10} mt={-19} px={{ xs: 1, sm: 0 }}>
          <Grid container spacing={3} justifyContent="center">
            <Grid item xs={12} lg={4}>
              <Card>
                <SoftBox pt={3} pb={2} px={2} textAlign="center">
                  <SoftBadge
                    variant="contained"
                    color="secondary"
                    size="sm"
                    badgeContent="ΣΤΟΙΧΕΙΑ ΕΠΙΚΟΙΝΩΝΙΑΣ"
                    circular
                    container
                  />
                </SoftBox>
                <SoftBox pb={3} px={3}>
                  <SoftBox key="lala" display="flex" alignItems="center" p={1}>
                    <SoftBox
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      width="1.5rem"
                      height="1.5rem"
                      borderRadius="50%"
                      shaodw="md"
                      bgColor="info"
                      variant="gradient"
                      mr={2}
                    >
                      <SoftTypography variant="button" color="white" sx={{ lineHeight: 0 }}>
                        <Phone />
                      </SoftTypography>
                    </SoftBox>
                    <SoftTypography variant="body2" color="text">
                      +30 2104445906
                    </SoftTypography>
                  </SoftBox>
                </SoftBox>
                <SoftBox pb={3} px={3}>
                  <SoftBox key="lala" display="flex" alignItems="center" p={1}>
                    <SoftBox
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      width="1.5rem"
                      height="1.5rem"
                      borderRadius="50%"
                      shaodw="md"
                      bgColor="info"
                      variant="gradient"
                      mr={2}
                    >
                      <SoftTypography variant="button" color="white" sx={{ lineHeight: 0 }}>
                        <Mail />
                      </SoftTypography>
                    </SoftBox>
                    <SoftTypography variant="body2" color="text">
                      info@portalx.gr
                    </SoftTypography>
                  </SoftBox>
                </SoftBox>

                <SoftBox pb={3} px={3}>
                  <SoftBox key="lala" display="flex" alignItems="center" p={1}>
                    <SoftBox
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      width="1.5rem"
                      height="1.5rem"
                      borderRadius="50%"
                      shaodw="md"
                      bgColor="info"
                      variant="gradient"
                      mr={2}
                    >
                      <SoftTypography variant="button" color="white" sx={{ lineHeight: 0 }}>
                        <Business />
                      </SoftTypography>
                    </SoftBox>
                    <SoftTypography variant="body2" color="text">
                      Φαρμακίδου 2, Αθήνα 11745
                    </SoftTypography>
                  </SoftBox>
                </SoftBox>
              </Card>
            </Grid>
          </Grid>
        </SoftBox>
      </Container>
      <SoftBox mt={8}>
        <Footer />
      </SoftBox>
    </PageLayout>
  );
}

export default ContactUs;
